// Model.js
// -----------------------
// @module Case
define("Eureka.MaxaPriceMatch.MaxaPriceMatch.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/MaxaPriceMatch/SuiteScript2/MaxaPriceMatch.Service.ss"
            ),
            true
        )
});
});
